import { useEffect, useRef } from 'react';
import { notifyOnce } from '@/utils';

export function useFirstTradeAchievementNotification({
	showFirstTradeModal,
	isUserHasTrades,
	userEmail,
}: {
	showFirstTradeModal: boolean;
	isUserHasTrades: boolean;
	userEmail: string | undefined;
}) {
	const notifiedRef = useRef(new Set());

	useEffect(() => {
		if (showFirstTradeModal && !isUserHasTrades) {
			notifyOnce(
				notifiedRef,
				'firstPrediction',
				userEmail,
				'Achievement Unlocked',
				"First prediction locked in! You're officially in the game!"
			);
		}
	}, [isUserHasTrades, showFirstTradeModal, userEmail]);
}
